// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"2f04d433","9":"bc4cbc71","255":"0983b38e","390":"5d256e4e","816":"2972e83d","923":"87af7edc"}[chunkId] + ".js";
};